// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"ad0cb65f","787":"272af0be","967":"6d875a47"}[chunkId] + ".chunk.js";
};